import { useMemo } from "react";
import { normalizePlot, isPlotValid, createEmptyPlot } from "../shared/utils/handlePlot";

export const useResolvedPlot = ({
  apiPlot,
  aiWorkflow,
  workflowNoContent,
}) => {
  const normalizedApiPlot = useMemo(() => {
    if (!Array.isArray(apiPlot)) return apiPlot || null;

    return normalizePlot({
      source: "API",
      items: apiPlot,
    });
  }, [apiPlot]);

  const normalizedAIPlot = useMemo(() => {
    if (!aiWorkflow?.items?.length) return null;

    return normalizePlot({
      source: "AI",
      items: aiWorkflow.items,
    });
  }, [aiWorkflow]);

  const resolvedPlot = useMemo(() => {
    if (workflowNoContent) {
        return createEmptyPlot();
    }

    if (isPlotValid(normalizedAIPlot)) {
        return normalizedAIPlot;
    }

    if (isPlotValid(normalizedApiPlot)) {
        return normalizedApiPlot;
    }

    return normalizedApiPlot || createEmptyPlot();
    }, [normalizedAIPlot, normalizedApiPlot, workflowNoContent]);

  const isAIActive =
   !!aiWorkflow || workflowNoContent;

  return {
    resolvedPlot,
    isAIActive,
  };
};
